export default "__VITE_ASSET__82023227__"